// @flow

import { observer } from "mobx-react";
import React from "react";
import WaveSurfer from "wavesurfer.js";

import "./AudioPlayerPreview.scss";

type Props = {
    onPlay?: Function,
    showPlayButton?: boolean,
    src: ?string
};

@observer
export default class AudioPlayerPreview extends React.Component<Props> {
    containerRef: ?HTMLElement;
    waveSurfer: ?WaveSurfer;

    setContainerRef = (containerRef: ?HTMLElement) => {
        this.containerRef = containerRef;
        this.tryInitWaveSurfer();
    };

    componentDidMount = () => {
        this.tryInitWaveSurfer();
    };

    tryInitWaveSurfer = () => {
        if (!this.waveSurfer && this.containerRef && this.props.src) {
            this.waveSurfer = WaveSurfer.create({
                container: this.containerRef,
                responsive: true,
                hideScrollbar: true,
                normalize: true
            });
            this.waveSurfer.load(this.props.src);
        }
    };

    componentWillUnmount = () => {
        if (this.waveSurfer) {
            this.waveSurfer.destroy();
            this.waveSurfer = null;
        }
    };

    render() {
        const classes = ["AudioPlayerPreview"];
        if (this.props.showPlayButton) {
            classes.push("AudioPlayerPreview--with-play-button");
        }

        return (
            <div className={classes.join(" ")} onClick={this.props.onPlay}>
                <div
                    className="AudioPlayerPreview__thumbnail"
                    ref={this.setContainerRef}
                ></div>

                {this.renderPlayButton()}
            </div>
        );
    }

    renderPlayButton() {
        return (
            <div className="AudioPlayerPreview__icon">
                <i className="glyphicon glyphicon-play" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/AudioPlayerPreview/AudioPlayerPreview.js